import { get } from 'lodash';
import {
    showPayForSelfError,
    trackViewedPayForSelfError,
} from 'src/Booking/pages/AppointmentInfo/AppointmentInfoPageActions';
import {
    shouldRecordExperiment,
    shouldShowPayForSelfError,
} from 'src/Booking/pages/ReviewAndBook/helpers';
import patientSelector from 'src/Booking/selectors/PatientSelector';
import {
    shouldRequireMemberIdSelector,
    shouldShowReviewAndBookScanner,
} from 'src/config/ab/selector';
import * as SchedulingActions from '../../actions/SchedulingActions';
import { showValidationErrors } from '../../components/AppointmentRequirements/AppointmentRequirementsActions';
import appointmentRequirementsSelector from '../../components/AppointmentRequirements/AppointmentRequirementsSelector';
import {
    PHONE_REQUIRED,
    INSURANCE_ID_REQUIRED,
} from '../../components/AppointmentRequirements/constants';
import { hasRequirement } from '../../components/AppointmentRequirements/helpers';
import { mentalHealthRequirementsIsValid } from '../../components/MentalHealthQuestionnaire/utils';
import {
    BookingStateProperties,
    APPOINTMENT_DETAILS_ROOT_KEY,
    DOCTOR_CARD_ROOT_KEY,
} from '../../constants';
import bookingStateSelector from '../../selectors/BookingStateSelector';
import reviewAndBookPageIsValid from '../../selectors/ReviewAndBookPageIsValid';
import {
    continueWasClicked,
    hideLoadingAnimation,
    showLoadingAnimation,
    showMissingFieldsError,
    showMentalHealthMissingError,
    trackViewedInsuranceIdError,
} from './actions';

const submitIfValid = (bookingId) => {
    return (dispatch, getState) => {
        const state = getState();
        const bookingState = bookingStateSelector(state);
        const bookingRequirements =
            bookingState[BookingStateProperties.requirements];

        //insurance id requirements
        const isMemberIdAlreadyRequired = hasRequirement(
            INSURANCE_ID_REQUIRED,
            bookingRequirements
        );
        const shouldRequireMemberId = shouldRequireMemberIdSelector(state);
        const professional = state[DOCTOR_CARD_ROOT_KEY].professional || {};
        const carrierId =
            bookingState[BookingStateProperties.insuranceCarrierId];
        const insuranceIdRequiredForExperiment =
            shouldRequireMemberId &&
            shouldRecordExperiment({
                requirements: bookingRequirements,
                professional,
                carrierId: carrierId,
                isMemberIdAlreadyRequired,
            });
        const insuranceIdRequired =
            insuranceIdRequiredForExperiment || isMemberIdAlreadyRequired;
        const patient = patientSelector(state);
        const { insuranceCardImageUrls } = patient.selectedInsuranceCard || {};
        const insuranceImage = insuranceCardImageUrls?.front;

        dispatch(continueWasClicked());
        dispatch(showValidationErrors(insuranceIdRequired));

        const requirements = appointmentRequirementsSelector(state);

        const insuranceNotCompleted =
            insuranceIdRequired &&
            (!state[APPOINTMENT_DETAILS_ROOT_KEY].insuranceId ||
                state[APPOINTMENT_DETAILS_ROOT_KEY].insuranceId.trim() === '');

        if (insuranceNotCompleted) {
            dispatch(trackViewedInsuranceIdError());
        }

        const phoneNumberRequired = hasRequirement(
            PHONE_REQUIRED,
            bookingRequirements
        );

        const specialtyId = get(
            state[DOCTOR_CARD_ROOT_KEY],
            'professional.specialtyId'
        );
        const isScannerExperimentOn = shouldShowReviewAndBookScanner(state);
        const hasInsuranceImageButPayForSelfSelected =
            shouldShowPayForSelfError({
                specialtyId,
                isScannerExperimentOn,
                insuranceImage,
                carrierId,
            });

        let isValid = true;
        if (hasInsuranceImageButPayForSelfSelected) {
            dispatch(showPayForSelfError());
            dispatch(trackViewedPayForSelfError());
        }
        if (
            !reviewAndBookPageIsValid(state) ||
            !requirements.isValid ||
            insuranceNotCompleted ||
            phoneNumberRequired ||
            hasInsuranceImageButPayForSelfSelected
        ) {
            dispatch(showMissingFieldsError());
            dispatch(hideLoadingAnimation());
            isValid = false;
        }

        //lifestance mental health validation

        if (!mentalHealthRequirementsIsValid(bookingState)) {
            dispatch(showMentalHealthMissingError());
            dispatch(hideLoadingAnimation());
            isValid = false;
        }

        if (!isValid) {
            return;
        }

        dispatch(
            SchedulingActions.submitBooking(bookingId, showLoadingAnimation)
        );
    };
};

export default submitIfValid;
